import { render } from "./MediaGallery.vue?vue&type=template&id=2ea291f7"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__